// import { appdata } from "./data/data";

export class GlobalConstants {
    public static appname: string = "brdFarm";
    // public static yearCr: string = "2425";
    // public static yearTh: string = "6768";
    public static appversion: string = "1.8.0 Beta";
    public static lastupdate: string = "20 พ.ค.67"
    public static versionDesc = [
        { "subject": "1.อัพเดตโปรไฟล์ เช่น รูปประจำตัว เบอร์โทร เบอร์sms ไลน์ไอดี เฟซไอดี อีเมล์" },
        { "subject": "2.แก้ไขฟอร์มบันทึกกิจกรรมแปลง แยกกิจกรรมอ้อยใหม่ อ้อยตอ" },
        { "subject": "3.อัพเดต รายงานกิจกรรมแปลง ตาม BRR Model" },
    ];
    public static yeardata: any = [];
    public static fmdata: any = [];
    public static cpFmdata: any = [];
    public static mapFbFm: any = [];
    public static _yearid: string = "";
    public static yearLabel: string = "";
    public static reportdate: string | null = null;
    public static supcode: string | null = null;

}

export function yearCr(): string {
    let yearCr: string;
    let yearnow: any = new Date().getFullYear();
    yearnow = yearnow.toString().substring(2, 4)
    // console.log('yearnow', yearnow)
    let yearnext: any = new Date().getFullYear() + 1;
    yearnext = yearnext.toString().substring(2, 4)
    // console.log('yearnext', yearnext)
    let yearpre: any = new Date().getFullYear() - 1;
    yearCr = yearnow.concat(yearnext)
    // console.log('yearCr', yearCr)
    return yearCr;
}

export function yearCrCPC(): string {

    const currentDate = new Date(); // ดึงวันที่ปัจจุบัน
    const currentMonth = currentDate.getMonth(); // ดึงเดือน (0 - 11)
    let yearCrCPC: string;
    let yearnow: any = new Date().getFullYear();
    yearnow = yearnow.toString().substring(2, 4)
    let yearpre: any = new Date().getFullYear() - 1;
    yearpre = yearpre.toString().substring(2, 4)
    let yearNext: any = new Date().getFullYear() - 1;
    yearNext = yearNext.toString().substring(2, 4)

    // ตรวจสอบว่าเป็นเดือนธันวาคม (11) หรือไม่
    if (currentMonth === 11) {
        yearCrCPC = yearnow.concat(yearNext)
        return yearCrCPC; // เดือนธันวาคมให้แสดงปีปัจจุบัน
    }

    // ตรวจสอบว่าเป็นเดือนมกราคมถึงเมษายน (0 - 3) หรือไม่
    if (currentMonth >= 0 && currentMonth <= 3) {
        yearCrCPC = yearpre.concat(yearnow)
        return yearCrCPC; // เดือนมกราคมถึงเมษายนให้แสดงปีที่ผ่านมา
    }

}

export function yearTh(): string {
    let yearTh: string;
    let yearnow: any = new Date().getFullYear() + 543;
    yearnow = yearnow.toString().substring(2, 4)
    let yearnext: any = new Date().getFullYear() + 544;
    yearnext = yearnext.toString().substring(2, 4)
    let yearpre: any = new Date().getFullYear() + 542;
    yearTh = yearnow.concat(yearnext)
    return yearTh;
}

export function yearLabel(): string {
    let yearLabel: string;
    let yearnow: any = new Date().getFullYear() + 543;
    yearnow = yearnow.toString().substring(2, 4)
    let yearnext: any = new Date().getFullYear() + 544;
    yearnext = yearnext.toString().substring(2, 4)
    yearLabel = yearnow.concat(yearnext)
    return yearLabel;
}